export const CollectAcceptType = {
  All: 'all',
  Image: 'image',
  Document: 'document',
  Audio: 'audio',
  Video: 'video',
  Compact: 'compact',
  Text: 'text',
}

export const CollectDestinationType = {
  A: 'a',
  B: 'b',
  C: 'c',
  D: 'd',
}
